import { Link } from "react-router-dom";

export const SUPPORT_EMAIL = "grievance@urgentsellbuy.com";
export const mailto = (subject) => `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;

const PolicyLink = () => <Link to="/legal/privacy" className="text-[#FF3838] underline">Privacy Policy</Link>;

export const TOPICS = [
  {
    id: "account",
    title: "Account registration & login",
    subject: "Support: Account registration / login",
    points: [
      "UrgentSellBuy is only for people aged 18 or over. Registration may ask for your name, email, mobile number, username, profile photo and date of birth (for age verification).",
      "If you can't register or sign in, email us from the address linked to your account. Include your username or registered mobile number, the device you're using, and a screenshot of any error message.",
      "Never share your password or one-time codes with anyone, including in emails to us.",
    ],
  },
  {
    id: "buying-selling",
    title: "Buying, selling & listings",
    subject: "Support: Buying / selling / listing",
    points: [
      "A listing contains a title, description, images, price and a state/city location. Your exact address is not part of a listing.",
      "For a problem with a listing, send us the listing title (or a screenshot of it) and describe what went wrong.",
      "To report a suspicious listing or user, include the listing title and the seller's username.",
    ],
  },
  {
    id: "chat",
    title: "Chat & messages",
    subject: "Support: Chat / messages",
    points: [
      "Buyers and sellers talk through chat messages and contact requests on the platform. When you start contact with someone, the relevant contact details are shared with them.",
      "If messages aren't sending or arriving, or you want to report a conversation, email us the other person's username and roughly when the messages were sent. A screenshot helps.",
    ],
  },
  {
    id: "payments",
    title: "Subscriptions & payments",
    subject: "Support: Subscription / payment",
    points: [
      "Payments on UrgentSellBuy are processed by Razorpay. UrgentSellBuy does not store your card or bank details.",
      "For a failed, duplicate or unclear payment, or a subscription question, email us the payment order ID or transaction ID, the date and the amount. Please don't send full card numbers, CVV or bank passwords.",
    ],
  },
  {
    id: "deletion",
    title: "Account deletion",
    subject: "Account deletion request",
    points: [
      "To delete your account, email us from the email address registered on your account, with the subject “Account deletion request” and your username.",
      <>After a deletion request, your personal data will be deleted within a reasonable time, except where the law requires us to keep it (for example tax records or an active legal dispute). See our <PolicyLink /> for details.</>,
    ],
  },
  {
    id: "privacy",
    title: "Privacy complaints",
    subject: "Privacy complaint",
    points: [
      <>For privacy-related complaints, contact our Grievance Officer at the email below. Under our <PolicyLink />, complaints are acknowledged within 24 hours and resolved within 15 days.</>,
    ],
  },
];
